<ng-container appSidebarActivity [activity]="activity"></ng-container>